import React, { useEffect } from "react";
import {
  useSearchParams,
  useNavigate,
} from "react-router-dom";

import { useTranslation } from "react-i18next";

export default function PaymentSuccess() {

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const { t } = useTranslation();

  const listingId =
    searchParams.get("listingId");

  const type =
    searchParams.get("type");

  useEffect(() => {

    const timer = setTimeout(() => {

      // extra listing OR limitless bought from posting-limit flow -> choose promotion
if (
  (type === "extra_listing" || type === "limitless") &&
  listingId
) {
  navigate("/listing-promotion", {
    state: { listingId },
    replace: true,
  });

  return;
}

      // promotion packages -> open listing
      if (
        (type === "vip" ||
         type === "gold" ||
         type === "extra_gold") &&
        listingId
      ) {

        navigate(`/listing/${listingId}`, {
  replace: true,
  state: { from: "/" },
});

        return;
      }

      // limitless bought outside posting-limit flow
if (type === "limitless") {
  navigate("/", { replace: true });
  return;
}

      navigate("/");

    }, 2000);

    return () => clearTimeout(timer);

  }, [listingId, type, navigate]);

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "80px",
      }}
    >
      <h1>✅ {t("payment.successTitle")}</h1>

      <p>
        {t("payment.successMessage")}
      </p>

      <p>
        {t("payment.redirecting")}
      </p>

    </div>
  );
}
